import {Route} from '@angular/router';
import {AuthGuard} from 'app/common/services/auth-guard.service';
import {IntegrationComponent} from '../../components/integration/integration.component';

export const integrationRoute: Route = {
  path: ':cityId/:clubNetId/:clubId/integration',
  component: IntegrationComponent,
  canActivate: [ AuthGuard ],
  data: {title: 'Integration'}
};
